import React from 'react';
import Section from '../components/Section';
import Profile from '../components/Profile';
import SEO from '../components/SEO';
import content from '../data/content.json';

const About: React.FC = () => {
  const about = content.about;
  const introSection = about.content.find(sec => sec.section === 'Intro');
  const introText = introSection?.text ? introSection.text.split('\n\n')[1] || '' : '';

  const lawyersSection = about.content.find(sec => sec.section === 'Lawyers');
  const profiles = lawyersSection?.profiles || [];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Advokatfirmaet Bruland",
    "url": "https://bruland.no/om-oss",
    "employee": [
      {
        "@type": "Person",
        "name": "Tove Kristin Farstad",
        "jobTitle": "Advokat",
        "worksFor": {
          "@type": "LegalService",
          "name": "Advokatfirmaet Bruland"
        }
      },
      {
        "@type": "Person",
        "name": "Thorleif G. Bruland",
        "jobTitle": "Advokat, Siviløkonom, MBA",
        "worksFor": {
          "@type": "LegalService",
          "name": "Advokatfirmaet Bruland"
        }
      }
    ]
  };

  return (
    <>
      <SEO
        title="Om oss - Erfarne advokater i Oslo"
        description="Møt våre erfarne advokater Tove Kristin Farstad og Thorleif G. Bruland. Vi har spesialkompetanse innen arv og skifte, arbeidsrett og fast eiendom."
        keywords="advokat Oslo, Tove Kristin Farstad, Thorleif G. Bruland, juridisk kompetanse, erfarne advokater"
        canonicalUrl="/om-oss"
        structuredData={structuredData}
      />
      {/* Page Header */}
      <Section
        title="Om oss"
        subtitle="Advokater med spesialkompetanse"
        background="gray"
        spacing="md"
        centered
      />

      {/* Firm Introduction */}
      <Section background="white" spacing="lg" container="narrow">
        <p className="text-lg leading-relaxed text-gray-700">
          {introText}
        </p>
      </Section>

      {/* Lawyer Profiles */}
      <Section title="Våre advokater" background="gray" spacing="lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-8">
          {profiles.map((prof, idx) => {
            const name = prof.name.replace(/^#+\s*/, '');
            // Map names to their image files
            const photoMap: { [key: string]: string } = {
              'Tove Kristin Farstad': '/privateImages/tove.webp',
              'Thorleif G. Bruland': '/privateImages/throleif.webp',
            };

            return (
              <Profile
                key={idx}
                name={name}
                title={prof.title}
                photo={photoMap[name]}
                practiceAreas={prof.practiceAreas}
                email={prof.email}
                phone={prof.phone}
                slug={prof.slug}
              />
            );
          })}
        </div>
      </Section>
    </>
  );
};

export default About;

